import auth from "@/helper/middleware/auth";
import admin from "@/helper/middleware/admin";

export default [
    {
        path: "/logs",
        name: "logs",
        component: () => import("@/views/log/LogsView.vue"),
        meta: { middleware: [auth, admin] },
    },
];
